module.exports = __webpack_public_path__ + "img/1.65f1422b.png";